import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsAdjustmentLoading } from 'common/engine/reducers/structuredDocumentDescriptionSlice';

const AdjustmentGroupExpansionButton = ({ title, expanded, onClick }) => {
  const isAdjustmentLoading = useSelector(getIsAdjustmentLoading);
  return (
    <>
      <button
        type="button"
        className="adjustment-group__toggle-button"
        id={`adjustment-group__toggle-button-${title}`}
        onClick={onClick}
        data-testid="adjustment-rollup-toggle-button"
        disabled={isAdjustmentLoading}
      >
        <span
          aria-hidden="true"
          data-testid="expanded-indicator-icon"
          className={`icon-expanded ${expanded ? 'asc' : 'desc'}`}
        >
          <Icon
            name="desc"
            width="10"
            className="fill icon-orange"
            viewBox="-4 0 32 32"
          />
        </span>
        <span className="adjustment-expansion-button-title">{title}</span>
      </button>
    </>
  );
};

AdjustmentGroupExpansionButton.propTypes = {
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AdjustmentGroupExpansionButton;
